var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 1.33325C5.03484 1.33325 5.33331 1.63173 5.33331 1.99992V2.66659H10.6666V1.99992C10.6666 1.63173 10.9651 1.33325 11.3333 1.33325C11.7015 1.33325 12 1.63173 12 1.99992V2.66659H13.3333C14.0697 2.66659 14.6666 3.26354 14.6666 3.99992V5.99992H1.33331V3.99992C1.33331 3.26354 1.93027 2.66659 2.66665 2.66659H3.99998V1.99992C3.99998 1.63173 4.29846 1.33325 4.66665 1.33325Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 12.6666C14.6666 13.403 14.0697 13.9999 13.3333 13.9999H2.66665C1.93027 13.9999 1.33331 13.403 1.33331 12.6666V7.33325H14.6666V12.6666ZM5.99998 9.99992C5.99998 9.63173 6.29846 9.33325 6.66665 9.33325H9.33331C9.7015 9.33325 9.99998 9.63173 9.99998 9.99992C9.99998 10.3681 9.7015 10.6666 9.33331 10.6666H6.66665C6.29846 10.6666 5.99998 10.3681 5.99998 9.99992Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.e3c3d237d07b2e602784a033e4b6f4a4.svg";
export { ForwardRef as ReactComponent };